import "../App.scss";
import TickImg from "../Assets/Images/thank-you-tick.svg";

const ThankYou = (props) => {
  return (
    <div className="container thank-you-final">
      <div className="details-container">
        <div className="tick">
          <img src={TickImg} alt="" />
        </div>
        <h1>Thank you very much for investing your time.</h1>
        <p className="thank-you-text">Your responses will directly shape how your church moves forward in faithfully using technology to glorify God and serve others. We look forward to discussing these insights in our upcoming sessions.</p>
        <div style={{ height: "20px" }}></div>
        <p className="thank-you-text thank-you-verse">"Now to him who is able to do immeasurably more than all we ask or imagine,<br/>according to his power that is at work within us." – Eph 3:20</p>
        <div style={{ height: "50px" }}></div>
      </div>
    </div>
  );
};

export default ThankYou;
